"use client";

import clsx from "clsx";
import type { ComponentProps } from "react";

import { Icon } from "@shared/ui/icon";
import { Link } from "@shared/ui/link";

import type { VacancyType } from "../../model";

import s from "./vacancy-list-item.module.scss";

export type VacancyListItemProps = ComponentProps<"div"> & {
  className?: string;
  cellClassName?: string;
  vacancy: VacancyType;
};

export const VacancyListItem = (props: VacancyListItemProps) => {
  const { className, cellClassName, vacancy } = props;

  return (
    <div className={clsx(s.root, className)}>
      <div className={s.inner}>
        {vacancy?.position && (
          <div className={clsx(s.cell, cellClassName)}>{vacancy?.position}</div>
        )}
        {vacancy?.salary && (
          <div className={clsx(s.cell, cellClassName)} data-label="Зарплата">
            {vacancy?.salary}
          </div>
        )}
        {vacancy?.experience && (
          <div className={clsx(s.cell, cellClassName)} data-label="Опыт">
            {vacancy?.experience}
          </div>
        )}

        <div className={clsx(s.cell, cellClassName)} data-label="Занятость">
          {vacancy?.busyness || ""}
          {vacancy?.link && (
            <Icon name="arrow-right" className={s.icon} size={24} />
          )}
        </div>
      </div>

      <Link
        variant="block"
        href={vacancy?.link}
        target="_blank"
        className={s.link}
        aria-label={
          vacancy?.position ? `Вакансия: ${vacancy.position}` : "Вакансия"
        }
      >
        &nbsp;
      </Link>
    </div>
  );
};

VacancyListItem.displayName = "VacancyListItem";
